import React, { useState, useCallback } from "react";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import styled from "styled-components";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import FadeInOnScroll from "../components/FadeInOnScroll";
import CallToAction from "../components/CallToAction";
import IntroBand from "../components/IntroBand";

const FUNCTION_SCORE_RECAPTCHA = 'https://us-central1-zendo-health.cloudfunctions.net/scoreRecaptcha';
const FUNCTION_ADD_MEMBER = 'https://us-central1-zendo-health.cloudfunctions.net/addMember';
const FUNCTION_ADD_COMPANY_DEAL = 'https://us-central1-zendo-health.cloudfunctions.net/addCompanyDeal';

const Hero = styled.div`
  z-index: 3;
  position: relative;

  nav {
    z-index: 3;
    position: relative;
  }
`;

const ContactLayout = styled.div`
  display: flex;
  padding: 30px 30px 0;
  position: relative;
  flex-direction: row;
  margin-right: auto;
  margin-left: auto;
  justify-content: center;
  width: 1300px;
  margin-bottom: -50px;

  @media screen and (max-width: 1000px) {
    padding: 50px 30px 0;
    margin-bottom: -20px;
    width: 700px;
    max-width: 100%;
    position: relative;
    flex-direction: column;
  }
`;

const ContactSubmitBox = styled.form`
  position: relative;
  height: 100%;
  width: 665px;
  max-width: 100%;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0px 16px 43px 0px #2f36303d;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  box-sizing: border-box;

  input::placeholder,
  textarea::placeholder {
    color: #5e8a64; /* Set your desired color here */
    opacity: 1; /* Optional: ensures full opacity on all browsers */
  }

  @media screen and (max-width: 1000px) {
    margin-top: 10px; /* Add margin to create space */
  }
`;

const ContactUs = styled.div`
  font-size: 28px;
  line-height: 1.27;
  color: black;
  padding: 5px;
`;

const ContactInput = styled.input`
  font-size: 18px;
  line-height: 1.27;
  width: 90%;
  border-radius: 6px;
  background: #5e8a641a;
  color: #5e8a64;
  padding: 15px;
  outline: none;
  border: none;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: start;
  align-items: start;
  pointer-events: auto;
  position: relative;
  font-family: Raleway;
`;

const ContactCheckbox = styled.input`
  font-size: 18px;
  font-family: Raleway;
  position: relative;
  left: -45%;
  top: 0px;
`;

const CheckboxLabel = styled.label`
  position: relative;
  margin: -32px 20px 0px 40px;
  font-family: Raleway;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  padding: 10px 0;
  color: black;
`;

const MessageInput = styled.textarea`
  font-size: 18px;
  line-height: 1.27;
  min-height: 150px; /* Set a minimum height */
  width: 90%;
  border-radius: 6px;
  background: #5e8a641a;
  color: #5e8a64;
  padding: 15px;
  outline: none;
  border: none;
  resize: none; /* Allow vertical resizing */
  overflow-y: auto; /* Add scrollbar when needed */
  margin-top: 20px;
  margin-bottom: 10px;
  text-align: start;
  align-items: start;
  pointer-events: auto;
  position: relative;
  font-family: Raleway;
`;

const SubmitButtonWrap = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  padding: 20px 12px;
`;

const SubmitButton = styled.button`
  margin-top: 10px;
  text-align: right;
  padding: 15px 50px;
  box-shadow: 0px 4px 4px 0px #2f363033;
`;

const ThankYouContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 100px, 50px;
  text-align: center;
`;

const ThankYouHeader = styled.div`
  font-family: Raleway;
  font-size: 42px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  padding: 40px;
  margin-top: 150px;
  @media screen and (max-width: 1000px) {
    margin-top: 50px;
  }
`;

const ThankYouText = styled.div`
  font-family: Raleway;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
`;

const ThankYouWrap = styled.div`
  padding: 20px;
  margin-bottom: 150px;
  @media screen and (max-width: 1000px) {
    margin-bottom: 50px;
  }
`;

const Gap50 = styled.div`
  display: block;
  height: 50px;
`;

const IntroBandAuthor = styled.div`
  font-family: Raleway;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
  margin-top: 15px;
`;

function Join() {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [submitted, setSumbitted] = useState(false);
  const [status, setStatus] = useState('');

  const [formData, setFormData] = useState({
    companyname: "", 
    companyphone: "",
    domain: "", 
    description: "", 
    name: "",
    email: "",
    phone: "",
    smsok: "",
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  // Handle reCAPTCHA verification
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      setStatus('reCAPTCHA not available');
      return null;
    }
    try {
      const token = await executeRecaptcha('submit');
      return token;
    } catch (error) {
      console.log(error);
      setStatus('reCAPTCHA verification failed');
      return null;
    }
  }, [executeRecaptcha]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');

    const token = await handleReCaptchaVerify();
    if (!token) {
      setStatus('Callback form failed. Please send us an email at info@zendo.health, or give us a phone call at 1-800-433-0262.');
      return;
    }

    try {
      // check reCAPTCHA
      const responseScoreRecaptcha = await fetch(
        FUNCTION_SCORE_RECAPTCHA,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...formData, 'g-recaptcha-response': token }),
        }
      );
      const resultScoreRecaptcha = await responseScoreRecaptcha.json();
      console.log("CAPTCHA verification successful. Result: ", resultScoreRecaptcha);
      if (resultScoreRecaptcha.success) {

        // reset vars
        setSumbitted(true);
        setStatus('Recaptcha passed!');

        const responseAddMember = await fetch(
          FUNCTION_ADD_MEMBER,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...formData }),
          }
        );
        const resultAddMember = await responseAddMember.json();
        console.log("Add member result: ", resultAddMember);

        const responseAddCompanyDeal = await fetch(
          FUNCTION_ADD_COMPANY_DEAL,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...formData }),
          }
        );
        const resultAddCompanyDeal = await responseAddCompanyDeal.json();
        console.log("Add company deal result: ", resultAddCompanyDeal);        
        if (resultAddCompanyDeal.status === "success") {
            console.log("Company deal created successfully.");
            setStatus('');
            setFormData({ name: '', email: '', phone: '', smsok: '', companyname: '', companyphone: '', domain: '', description: '' });
        } else {
          setStatus('Add company failed. Please send us an email at info@zendo.health, or give us a phone call at 1-800-433-0262.');
          console.log("Add company deal failed.");
        }
      } else {
        console.log("reCAPTCHA failed result: ", resultScoreRecaptcha);
        setStatus('reCAPTCHA failed. Please send us an email at info@zendo.health, or give us a phone call at 1-800-433-0262.');
      }
    } catch (error) {
      setStatus('Join failed. Please send us an email at info@zendo.health, or give us a phone call at 1-800-433-0262.');
    } 
  };

  return (
    <FadeInOnScroll>
      <main>
        <div className="green-bg">
          <Hero>
            <Nav />
            <ContactLayout>
              <ContactSubmitBox id="contact-form" onSubmit={handleSubmit}>
                {submitted && (
                  <>
                    <ThankYouContent>
                      <ThankYouHeader>{"Thank You"}</ThankYouHeader>
                      <ThankYouWrap>
                        <ThankYouText>
                          {status && <p>{status}</p>}      
                        </ThankYouText>
                        <ThankYouText>
                          {"If you requested that someone contact you,"}
                        </ThankYouText>
                        <ThankYouText>
                          {"expect to hear back within 1 business day."}
                        </ThankYouText>
                      </ThankYouWrap>
                    </ThankYouContent>
                  </>
                )}

                {!submitted && (
                  <>
                    {status && <p>{status}</p>}      
                    <ContactUs>{"Tell us about your business."}</ContactUs>
                    <ContactInput
                      type="text"
                      id="companyname"
                      placeholder="Company Name*"
                      value={formData.companyname}
                      onChange={handleChange}
                      required
                    />
                    <ContactInput
                      type="text"
                      id="companyphone"
                      placeholder="Company Phone (optional)"
                      value={formData.companyphone}
                      onChange={handleChange}
                    />
                    <ContactInput
                      type="text"
                      id="domain"
                      placeholder="Company Website (optional)"
                      value={formData.domain}
                      onChange={handleChange}
                    />
                    <MessageInput
                      type="text"
                      id="description"
                      placeholder="Please describe your business (optional)"
                      value={formData.description}
                      onChange={handleChange}
                    />

                    <ContactUs>{"Tell us who to contact."}</ContactUs>
                    <ContactInput
                      type="text"
                      id="name"
                      placeholder="Contact Name*"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                    <ContactInput
                      type="email"
                      id="email"
                      placeholder="Contact Email*"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                    <ContactInput
                        type="text"
                        id="phone"
                        placeholder="Contact Phone*"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    <ContactCheckbox
                        type="checkbox"
                        id="smsok"
                        value={formData.smsok}
                        onChange={handleChange}
                      />
                    <CheckboxLabel for="smsok">By checking this box you agree to receive SMS text message appointment reminders and conversational text messages from Zendo Health for business purposes. Reply STOP to opt out at any time. Reply HELP for Customer Care contact information. Messages and data rates may apply. Message frequency will vary. See our <a href="https://zendo.health/privacy">Privacy Policy</a>.</CheckboxLabel>
                    
                    <SubmitButtonWrap>
                      <SubmitButton type="submit">Submit</SubmitButton>
                    </SubmitButtonWrap>
                  </>
                )}
              </ContactSubmitBox>
            </ContactLayout>
          </Hero>
          <IntroBand>
            <Gap50 />
            "Between stimulus and response there is a space. In that space is
            our power to choose our response. In our response lies our growth
            and our freedom."
            <IntroBandAuthor>- Viktor E. Frankl</IntroBandAuthor>
          </IntroBand>
        </div>
        <CallToAction />
      </main>
      <Footer />
    </FadeInOnScroll>
  );
}

export default Join;
